const form = () => {
    const defaultEmail = $('.wpcf7-dynamichidden.location-email').val();
    $('.js__location-select').on('change', function () {
        let email = $(this).find(":selected").val();
        if (email.length) {
            $(this).closest('form').find('.wpcf7-dynamichidden.location-email').val(email);
        } else {
            $(this).closest('form').find('.wpcf7-dynamichidden.location-email').val(defaultEmail);
        }
    });

    $('.gdpr-terms label').on('click', function (e) {
        e.preventDefault();
        let childInput = $(this).find('input');
        if ($(this).hasClass('checked')) {
            childInput.prop('checked', false);
            $(this).removeClass('checked');
        } else {
            childInput.prop('checked', true);
            $(this).addClass('checked');
        }
    });
}